<template>
  <div class="table_content">
    <div class="company_table">
      <el-table
        ref="table"
        size="small"
        height="100%"
        header-cell-class-name="brand-table-header-cell"
        cell-class-name="brand-table-cell"
        v-loading="loading"
        :data="companyList"
      >
        <el-table-column label="品牌" prop="brandName"></el-table-column>
        <el-table-column label="关键词" prop="keyword"></el-table-column>
        <el-table-column label="站点" prop="sourceSite"></el-table-column>
        <el-table-column label="指数" prop="index"></el-table-column>

        <el-table-column
          label="时间日期"
          prop="date"
          :formatter="formaterTime"
        ></el-table-column>
        <el-table-column
          label="入库时间"
          prop="createTime"
          :formatter="formaterTime"
        ></el-table-column>
      </el-table>
    </div>

    <div ref="pagination" class="pagination">
      <el-button size="small" type="primary" @click="exportFunc">
        导出
      </el-button>
      <el-pagination
        :current-page="params.page"
        :page-size="params.size"
        :total="params.total"
        layout="total, prev, pager, next"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 列表数据
    companyList: {
      type: Array,
      default: () => [],
    },
    // 分页器数据
    params: {
      type: Object,
      default: () => {
        return {
          page: 1,
          size: 10,
          total: 0,
        }
      },
    },
    // 是否加载中
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changePage(page) {
      this.$emit('change-page', page)
    },
    formaterTime(row, column, cellValue, index) {
      // if (row.companyStatus === 1) {
      //   return "永久";
      // }
      const newTime = this.$moment(cellValue).format('YYYY-MM-DD')
      return newTime
    },
    exportFunc() {
      console.log('看看这里')
      this.$emit('export')
    },
  },
}
</script>

<style lang="scss">
.no-margin {
  margin: 0;
}
.center-children {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.pagination {
  // text-align: right;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table_content {
  width: 100%;
  display: flex;
  flex-direction: column;
  .company_table {
    flex: 1;
    height: 0;
  }
  .pagination {
    height: 32px;
  }
  .logo {
    height: auto;
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/indexQuery/queryTable.vue